import React, { Component } from 'react'
import classnames from 'classnames'
import { Div, H3, Icon } from '@driftt/tide-core-legacy'
import { getChildNodes } from './util'

import './style.styl'

class Subnav extends Component {

  static defaultProps = {
    mode: 'slide',
    open: true
  }

  constructor(props) {
    super(props)

    this.state = {
      open: props.open
    }

    this.onToggle = this.onToggle.bind(this)
  }

  onToggle () {
    const { onToggle } = this.props

    onToggle && onToggle()
    this.setState({ open: !this.state.open })
  }

  render () {
    const { open } = this.state
    const { className, mode } = this.props

    const modeClassName = `tc-subnav--${mode}`
    const nodes = getChildNodes(this.props.nodes)

    return (
      <Div className={classnames("tc-subnav-wrapper", { 'tc-subnav-wrapper--collapsed': !open })}>
        <Div className={classnames("tc-subnav", { 'tc-subnav--collapsed': !open }, modeClassName, className)}>
          <H3 className="tc-subnav-header">{this.props.title}</H3>
          <Div className="tc-subnav-content">
              {nodes}
          </Div>
        </Div>
        <Div className={classnames('tc-subnav-toggle-button', { 'tc-subnav-toggle-button--collapsed': !open })} onClick={this.onToggle}>
          <Icon name="arrow-1-left" width="8" height="8" />
        </Div>
      </Div>
    )
  }
}


export default Subnav



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Subnav/index.js